import $ from 'jquery';
import { isInViewPort, scrollToElement } from '../utils/Utils';

const $tabs = $('.js_tab');
const $tabsContent = $('.js_tab_content');

const init = () => {
    history.scrollRestoration = 'manual';

    $tabs.on('click', function(e) {
        e.preventDefault();

        $(this)
            .addClass('active')
            .parent()
            .siblings()
            .children()
            .removeClass('active');

        const $target = $tabsContent.children(`${this.hash}`);

        $target.siblings('.active').fadeOut(500, function() {
            $(this).removeClass('active');

            $target.fadeIn(500).addClass('active');
        });

        history.replaceState(null, '', this.hash);

        if (!isInViewPort(this)) {
            scrollToElement(this);
            history.replaceState(null, '', location.pathname);
        }
    });

    $tabs.filter(`[href="${location.hash}"]`).trigger('click');
};

export default init();
